











export default {
  name: 'Testeminie',
  props: {
    clients: {
      type: Array,
      required: true
    }
  }
}
